import CompanyLogDTO, { CompanyLogType } from "@/dto/CompanyLogDTO";
import PagedStore, { PagedParams, PagedResult } from "./PagedStore";
import { getCompanyLogList } from "@/services/api/companyLog";
import { makeObservable, actionBound } from "mobx";

class CompanyLogStore extends PagedStore<CompanyLogDTO> {
    constructor(public companyLogType: CompanyLogType) {
        super();

        makeObservable(this, {
            _loadDataImpl: actionBound,
        });

        this.loadData();
    }

    async _loadDataImpl(params: PagedParams<null>): Promise<PagedResult<CompanyLogDTO>> {
        const { pageNo, pageSize } = params;

        const { totalCount, items } = await getCompanyLogList({
            pageNo,
            pageSize,
            logType: this.companyLogType,
        });

        return {
            list: items,
            total: totalCount,
        };
    }
}

export default CompanyLogStore;
